// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"434":"1570954e","453":"1247f4d6","937":"bdc3dd91"}[chunkId] + ".chunk.js";
};